<template>
  <ul class="nav" v-if="activeEvent">
    <li class="nav-profile">
      <a href="javascript:;" v-on:click="expand()">
        <div class="cover with-shadow"></div>
        <div class="info">
          <b class="caret pull-right"></b>
          <small class="mb-1">Active event</small>
          {{ activeEvent.name }}
        </div>
      </a>
    </li>
    <li>
      <ul
        class="nav nav-profile"
        v-bind:class="{
          'd-block':
            this.stat == 'expand' && !this.pageOptions.pageSidebarMinified,
          'd-none': this.stat == 'collapse'
        }"
      >
        <li>
          <a href="/event" class="active"
            ><i class="fa fa-th-large"></i>Events</a
          >
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'
import { mapState } from 'vuex'

export default {
  name: 'EventActive',
  computed: {
    ...mapState('event', ['activeEvent'])
  },
  data() {
    return {
      stat: 'expand',
      pageOptions: PageOptions
    }
  },
  methods: {
    expand: function () {
      this.stat = this.stat == 'expand' ? 'collapse' : 'expand'
    }
  }
}
</script>
